import { useEffect, useState } from 'react'
import { CalBox } from './Calculation-box'
import { Button } from '../../../../../components'
import { getTotalAmt, getOrderSummary } from '../../../lib/onlpos-utils'
import {  
  onlposCreatePayData,
  onlposUpdateOrderStatus2,
} from '../../../lib/api-onlpos'
import { debug } from '../../../../../settings'

export function RightBoxPay(props) {
  const { tableOrderList } = props

  // const [, setNumValue] = useState("0")

  const [prcFields, setPrcFields] = useState({
    totalAmt: '0',
    discountAmt: '0',
    payAmt: '0',
    receivedAmt: '0',
    payedAmt: '0',
    changeAmt: '0',
    supplyAmt: '0',
    vatAmt: '0',
  })

  useEffect(() => {
    start()
  }, [tableOrderList])

  const start = () => {
    try {
      const amt = getTotalAmt(tableOrderList)
      const totalAmt = amt.toString()
      const payAmt = totalAmt
      const receivedAmt = totalAmt
      const vatAmt = Math.round((amt * 1) / 11).toString()
      const supplyAmt = (amt - parseInt(vatAmt)).toString()

      setPrcFields((pre) => {
        return {
          ...pre,
          totalAmt,
          payAmt,
          receivedAmt,
          supplyAmt,
          vatAmt,
        }
      })
    } catch (e) {
      alert(e.message)
    }
  }

  const allProps = { ...props, prcFields, setPrcFields }

  const styles = {
    wrap: {
      width: '55%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    top: {
      flex: 1,
      // backgroundColor: 'yellow',
    },
    btm: {
      // backgroundColor: 'azure',
      padding: 3,
    },
  }
  return (
    <div style={styles.wrap}>
      <div style={styles.top}>
        <CalBox {...allProps} />
      </div>
      <div style={styles.btm}>
        <Buttons {...allProps} />
      </div>
    </div>
  )
}

function Buttons(props) {
  const {
    shopInfo,
    gStyle,
    setVisiblePaySection,
    // setVisibleOrderSection,
    prcFields,
    orderList,
    // tableOrderList,
    selectedTableInfo,
    updateOrderList,
  } = props

  const onPayCash = async () => {
    try {
      const tableOrders = orderList.filter(
        (o) => o.tableCode === selectedTableInfo.tableCode,
      )
      if (tableOrders.length !== 1) throw Error('No Order Found!')

      const orderSummary = getOrderSummary(tableOrders[0].orderData?.orderList)

      if (debug) {
        console.log('receivedAmt', prcFields.receivedAmt)
        console.log('tableCode', selectedTableInfo.tableCode)
        console.log(orderSummary.orderAmt, prcFields.receivedAmt)
      }

      if (orderSummary.orderAmt !== prcFields.receivedAmt) {
        throw Error('금액이 다릅니다!(테스트는 동일한 금액으로...)')
      }

      // console.log('tableOrders[0]', tableOrders[0])
      // throw Error('onlposPayDataCreate 은 별도로 API를 작성해야 함.')

      const payDataObj = {
        tableCode: tableOrders[0].tableCode,
        orderData: JSON.stringify(tableOrders[0].orderData),
        isPaid: true,
        posName: shopInfo.posName,
        pgName: 'cash',
        orderName: orderSummary.orderName,
        orderAmt: prcFields.receivedAmt,
        payData: JSON.stringify({
          amt: prcFields.receivedAmt,
          payMethod: 'cash',
        }),
        ver: 'v3',
      }

      if (debug) {
        console.log(JSON.stringify(payDataObj, null, 2))
      }
      let res = await onlposCreatePayData({
        shopInfo,
        body: payDataObj,
      })
      if (res.err) throw Error(res.err.message)

      const newOrderData = {
        ...tableOrders[0].orderData,
        orderList: [],
      }

      res = await onlposUpdateOrderStatus2({
        shopInfo,
        tableCode: selectedTableInfo.tableCode,
        body: {
          orderData: JSON.stringify(newOrderData),
        },
      })
      if (res.err) throw Error(res.err.message)

      // console.log('resPayDataSave', res.result)

      await updateOrderList()
      setVisiblePaySection(false)
      // setVisibleOrderSection(false)
    } catch (e) {
      alert(e.message)
    }
  }

  const styles = {
    wrap: {
      display: 'flex',
      alignItems: 'center',
      margin: 3,
    },
    btn: {
      marginRight: 3,
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    text: { ...gStyle.text },
  }

  return (
    <div style={styles.wrap}>
      <Button
        style={styles.btn}
        variant="danger"
        onClick={() => alert('NOT SUPPORTED YET')}
      >
        신용<span>카드</span>
      </Button>

      <Button
        style={styles.btn}
        title="현금결제"
        variant="outline-secondary"
        onClick={onPayCash}
      />

      <Button
        style={styles.btn}
        title="닫기"
        variant="primary"
        onClick={() => setVisiblePaySection(false)}
      />
    </div>
  )
}
